module.exports = __webpack_public_path__ + "img/Primordial-Process-4-mobile.f042ec34.png";